
import Text from '../Text';

type PageHeaderProps = {
  title?: React.ReactNode | string;
  description?: string;
  dataIcTitle: string;
};

const PageHeader = ({ title, description, dataIcTitle }: PageHeaderProps) => {
  return (
    <>
      {title && (
        <Text
          as='h1'
          kind='blue'
          size='xl'
          className='pt-2 font-bold leading-snug'
          data-ic-title={dataIcTitle}
        >
          {title}
        </Text>
      )}

      {description && (
        <Text kind='gray' className={title ? '' : 'pt-4 text-lg leading-tight'}>
          {description}
        </Text>
      )}
    </>
  );
};

export default PageHeader;
